import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import WrapperService from './app';
import {
  domElementGetter,
} from '@creditasmx-utilities/helpers';

datadogRum.init({
  applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID as string,
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN as string,
  service: process.env.REACT_APP_DATADOG_SERVICE,
  env: process.env.REACT_APP_ENVINRONMENT,
  version: process.env.__VERSION__,
  site: 'datadoghq.com',
  sessionSampleRate: 70,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  sessionReplaySampleRate: 20,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask-user-input',
  allowedTracingUrls: [
    { match: 'https://api.creditas.io', propagatorTypes: ['datadog'] },
    { match: /https:\/\/.*\.creditas\.io/, propagatorTypes: ['datadog'] },
  ],
});

datadogRum.startSessionReplayRecording();

datadogLogs.init({
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN as string,
  version: process.env.REACT_APP_DATADOG_VERSION,
  service: process.env.__VERSION__,
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  sampleRate: 100,
});

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: WrapperService,
  domElementGetter: () => domElementGetter('root'),
});

export const bootstrap = [reactLifecycles.bootstrap];

export const mount = [reactLifecycles.mount];

export const unmount = [reactLifecycles.unmount];
